module.exports = __webpack_public_path__ + "static/media/icon-02.2ab5c604.png";